import config from "./config";
import { reactLocalStorage } from "reactjs-localstorage";

async function sendGuiDataEvent(data) {
  try{
// ----> msisdn calc 
const hostname = window.location.hostname.toLowerCase();
const operatorId = hostname.includes("mtncmre") ? "mtncmr_evina" : "mtncmr";

const guiDataEvent = {
    w_country:"CM",
    w_click_time: new Date().toISOString(),
    ref: document.referrer || "NA",
    operator_id:  operatorId,
    ua: navigator.userAgent,
    w_host: window.location.hostname, 
    w_req_url: window.location.href,
    req_time: new Date().toISOString(), 
    ts: new Date().toISOString(),
    w_device: null,
    opt: "MTN",
    service: "livexgames",
    uid: reactLocalStorage.get("uid")
      ? reactLocalStorage.get("uid")
      :'NA' ,
    msisdn: reactLocalStorage.get("msisdn")
      ? reactLocalStorage.get("msisdn")
      :'NA' ,
    mtype:localStorage.getItem("mtype") || "",
    blocked : localStorage.getItem("blocked") || 0,
    breason : localStorage.getItem("breason") || "",
    sid:localStorage.getItem("sessionId") || "",
    campid : reactLocalStorage.get("camp") || sessionStorage.getItem("camp") || "",
    rcid: reactLocalStorage.get("rcid") || sessionStorage.getItem("rcid") || "",
  };
  let objData = { ...guiDataEvent,...data};
  var jsonData_base64 = window.btoa(JSON.stringify(objData)); //base_64
  let url = config.get("elastic_base_url");
    const response = await fetch(url, {
      method: "POST",
      headers: { "guiTopic": "waplogs" },
      body: jsonData_base64,
      keepalive:true
    });

    if (response.ok) {
      console.log("the data is:",data)
       console.log("resp>>>",response)
      return true;
    } else {
      console.log("API request failed with status:", response.status);
      return false;
    }
  } catch (error) {
    console.log("Error sending event:", error);
    return false;
  }
}

export function SendGuiDataEvents(data) {
  sendGuiDataEvent(data).then((success) => {
    if (success) {
      console.log("The event is send")
    } else {
      console.log("The event is not send")    
    }
  });
}



